// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// Update
import UpdateCoordinator from '@/graphql/coordinators/update/updateCoordinator.gql';
import InsertCoordinators from '@/graphql/coordinators/insert/insertCoordinators.gql';
import DeleteCoordinator from '@/graphql/coordinators/delete/deleteCoordinator.gql';

export default {
	state: {
		coordinators: [],
	},

	// ================ Getters ================
	getters: {
		coordinators(state: any) {
			return state.coordinators;
		},
	},

	// ================ Mutations ================
	mutations: {
		setCoordinators(state: any, coordinators: any) {
			state.coordinators = coordinators;
		},
	},

	// ================= Actions =================
	actions: {
		async getCoordinators({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query MyQuery {
						coordinators {
							id
							first_name
							last_name
							phone_number
							email
							city
							cityByCity {
								country {
									id
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { coordinators } = response.data;
			commit('setCoordinators', coordinators);
			return;
		},

		async insertCoordinator({ dispatch }: any, payload: any) {
			const objects = [
				{
					first_name: payload.firstName,
					last_name: payload.lastName,
					phone_number: payload.phoneNumber,
					email: payload.email,
					city: payload.city,
				},
			];

			await apolloClient
				.mutate({
					mutation: InsertCoordinators,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getCoordinators');
			return;
		},

		async deleteCoordinator({ dispatch }: any, payload: any) {
			const { id } = payload;
			await apolloClient
				.mutate({
					mutation: DeleteCoordinator,
					// Parameters
					variables: {
						coordinatorId: id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getCoordinators');
			return;
		},

		async updateCoordinator({ dispatch }: any, payload: any) {
			const { firstName, lastName, phoneNumber, email, city, id } = payload;
			await apolloClient.mutate({
				mutation: UpdateCoordinator,
				// Parameters
				variables: {
					coordinatorId: id,
					firstName,
					lastName,
					phoneNumber,
					email,
					city,
				},
			});

			dispatch('getCoordinators');
			return;
		},
	},
};
